module.exports = __webpack_public_path__ + "static/media/glygenNotFoundSmall.bcb57ba1.svg";